import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
// import 'antd/dist/antd.css'

const container = document.getElementById('root');

if (container !== null) {
    const root = createRoot(container); // Create root with React 18 API
    root.render(<App />);
} else {
    console.error("Root element not found!"); // Log error if container is null
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
